<template>
  <v-avatar
    v-ripple
    icon
    :size="size"
    :style="style"
    class="outline"
    :tile="!rounded"
  >
    <v-btn
      v-if="!isNameEmpty"
      icon
      dark
      outlined
      @click="() => $router.push('/profile', () => {})"
    >
      {{ text | initials }}
    </v-btn>
  </v-avatar>
</template>

<script>
export default {
  /**
   * @displayName Avatar
   */
  name: 'Avatar',
  filters: {
    initials(value) {
      const parts = value.split(/[ -]/)
      let initials = ''
      for (let i = 0; i < parts.length; i += 1) {
        initials += parts[i].charAt(0)
      }
      if (initials.length > 3 && initials.search(/[A-Z]/) !== -1) {
        initials = initials.replace(/[a-z]+/g, '')
      }
      initials = initials.substr(0, 3).toUpperCase()
      return initials
    }
  },
  props: {
    /**
     * The image if text is not set or is empty string.
     */
    image: {
      type: String,
      default: ''
    },
    /**
     * The text if image is not set.
     */
    text: {
      type: String,
      default: ''
    },
    /**
     * The size of avatar (sets width and height equally).
     */
    size: {
      type: String,
      default: '50'
    },
    rounded: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    isNameEmpty() {
      return !this.text.replace(/^\s+/g, '').length
    },
    style() {
      const style = {
        border: 'initial',
        background: `transparent url('${this.image}') no-repeat scroll 0% 0% / ${this.size}px ${this.size}px content-box border-box`
      }

      return this.image ? style : ''
    }
  }
}
</script>
